import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',

  state: {
    errorMessage: null,
  },
  mutations: {
    setErrorMessage(state, message) {
      state.errorMessage = message;
    },
    clearErrorMessage(state) {
      state.errorMessage = null;
    },
  },
  actions: {
    showErrorMessage({ commit }, message) {
      commit('setErrorMessage', message);
      setTimeout(() => {
        commit('clearErrorMessage');
      }, 5000); // Después de 5 segundos, limpiar el mensaje de error
    },
  },
})

export default store

